import { render } from "./MellonWebECRTransactionResultLabel.vue?vue&type=template&id=cbdf663a"
import script from "./MellonWebECRTransactionResultLabel.vue?vue&type=script&lang=js"
export * from "./MellonWebECRTransactionResultLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__